import {IMdColorsService} from '../common/common.types';

export interface IColorDefinition {
  backgroundColor: string,
  foregroundColor: string,
  iconColor: string,
}

export interface IChartColorService {
  getColors(index:number):IColorDefinition;
}

export namespace IChartColorService {
  export const BLACK_COLORS = {
    backgroundColor: 'rgba(0, 0, 0, 1)',
    foregroundColor: 'rgba(255, 255, 255, 1)',
    iconColor: 'rgba(255, 255, 255, 1)'
  }
}

export default class ChartColorService implements IChartColorService {
  static $inject = ['$mdColors'];

  static COLORS = [
      'deep-purple', 'light-blue', 'green', 'yellow',
      'blue-grey', 'indigo', 'cyan', 'light-green', 'amber',
      'brown', 'purple', 'blue', 'teal', 'lime', 'grey'
  ];

  static DARK_BACKGROUNDS = [
      true, true, false, false, false, true, true, true, true, false, false,
      false, true, true, true, true, false, false, false
  ];

  constructor(private $mdColors:IMdColorsService) {
  }

  getColors(index:number) {
    return {
      backgroundColor: this.getColor(index),
      foregroundColor: ChartColorService.getForegroundColor(index),
      iconColor: ChartColorService.getIconColor(index)
    };
  }

  private getColor(index:number) {
    return this.$mdColors.getThemeColor(
        `${ChartColorService.
            COLORS[index % ChartColorService.COLORS.length]}-500-1`);
  }

  private static getForegroundColor(index:number) {
    if (ChartColorService.DARK_BACKGROUNDS[index]) {
      return 'rgba(255, 255, 255, 1)';
    } else {
      return 'rgba(0, 0, 0, 1)';
    }
  }

  private static getIconColor(index:number){
    if (ChartColorService.DARK_BACKGROUNDS[index]) {
      return 'rgba(255, 255, 255, 1)';
    } else {
      return 'rgba(0, 0, 0, .54)';
    }
  }
}



/** WEBPACK FOOTER **
 ** ./app/utils/chart-color.service.ts
 **/